<template>
  <div>
    <b-card
      id="container"
      ref="container"
    >
      <div class="ticket-center-main">
        <List :tab-index="tabIndex" />
      </div>
    </b-card>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { BCard } from 'bootstrap-vue'
import List from './List.vue'

export default {
  components: {
    List,
    BCard,
  },
  props: {
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    socket: null,
  }),
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
  },

  setup() {
    return {

    }
  },
}
</script>
<style lang="scss" scoped>
</style>
